import dayjs from 'dayjs'

/** 审核明细：驳回 / 申诉中 / 申诉未通过 */
const REJECT_RELATED_REVIEW_STATUS = new Set([3, 5, 7])

export function formatTtVersionLabel(ttVersion) {
  const n = Number(ttVersion)
  if (ttVersion == null || ttVersion === '' || Number.isNaN(n) || n <= 0) {
    return '—'
  }
  return `V${n}`
}

function parseSubmitTime(timeStr) {
  if (!timeStr) return 0
  return new Date(String(timeStr).replace(/\//g, '-')).getTime()
}

export function formatReviewFinishedTime(timeStr) {
  if (!timeStr) return '—'
  const parsed = dayjs(String(timeStr).replace(/\//g, '-'))
  return parsed.isValid() ? parsed.format('YYYY/MM/DD HH:mm') : String(timeStr)
}

/**
 * 版本记录 items 中取「最新一条驳回相关」记录（按送审时间倒序）
 * 含 reviewStatus 3 审核驳回、5 申诉中、7 申诉未通过
 */
export function pickLatestRejectedVersionRecord(items) {
  const sorted = [...(items || [])].sort(
    (a, b) => parseSubmitTime(b.submittedAt) - parseSubmitTime(a.submittedAt)
  )
  return (
    sorted.find((item) =>
      REJECT_RELATED_REVIEW_STATUS.has(Number(item.reviewStatus))
    ) || null
  )
}

/** 处理驳回弹窗展示字段 */
export function buildOverRuleDetailFromVersionRecord(record) {
  if (!record) return null
  const reason = (record.resultDescription || '').trim()
  return {
    submitVersion: formatTtVersionLabel(record.ttVersion),
    ttVersion: record.ttVersion,
    resultTime: formatReviewFinishedTime(record.finishedAt),
    fullRejectReason: reason || '—'
  }
}
